import React from "react";
import StackedBarChart from "./StackedBarChart";
import CompositionTable from "./CompositionTable";
import { useTranslation } from "../../hooks/useTranslation";

/* Painel de métrica em linha cheia: KPI à esquerda no topo, corpo com
   gráfico (~2/3) + tabela de composição (~1/3) lado a lado. Em telas
   estreitas (<960px, via CSS) colapsam num único bloco com o toggle
   Gráfico/Tabela — comportamento aprovado no mockup. */
const ChartIcon = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M3 3v18h18" />
    <rect x="7" y="10" width="3" height="7" />
    <rect x="12" y="6" width="3" height="11" />
    <rect x="17" y="13" width="3" height="4" />
  </svg>
);

const TableIcon = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <rect x="3" y="3" width="18" height="18" rx="2" />
    <path d="M3 9h18M3 15h18M9 3v18" />
  </svg>
);

const MetricPanel = ({
  metricKey, // 'jobs' | 'pages' | 'cost'
  label,
  dotColor,
  summary, // resposta do /summary
  colorByKey,
  groupsWithColor,
  dimensionLabel,
  formatter,
  caption,
  view = "chart", // usado apenas no layout colapsado (<960px)
  onToggleView,
  onBarClick,
  loading = false,
}) => {
  const { t } = useTranslation("consumption");
  const buckets = summary?.buckets || [];
  const matrix = summary?.series?.[metricKey] || [];
  const composition = summary?.composition || [];
  const total = summary?.totals?.[metricKey] || 0;

  return (
    <div
      className={`card panel ${view === "table" ? "tableview" : ""}`}
      data-metric={metricKey}
    >
      <div className="panel-head">
        <div className="panel-meta">
          <div className="panel-label">
            <span className="dot" style={{ background: dotColor }} />
            {label}
          </div>
          <div className="panel-total">
            <span className="big">{loading ? "…" : formatter(total)}</span>
          </div>
          <div className="panel-cap">{caption}</div>
        </div>
        <div className="seg sm panel-toggle">
          <button
            type="button"
            className={view === "chart" ? "on" : ""}
            title={t("chartView")}
            onClick={() => onToggleView && onToggleView("chart")}
          >
            <ChartIcon />
          </button>
          <button
            type="button"
            className={view === "table" ? "on" : ""}
            title={t("tableView")}
            onClick={() => onToggleView && onToggleView("table")}
          >
            <TableIcon />
          </button>
        </div>
      </div>
      <div className="panel-body">
        <div className="panel-chart">
          {loading ? (
            <div className="panel-loading">{t("loading")}</div>
          ) : (
            <StackedBarChart
              buckets={buckets}
              groups={groupsWithColor}
              matrix={matrix}
              granularity={summary?.period?.granularity || "day"}
              formatter={formatter}
              metricLabel={label}
              onBarClick={onBarClick}
            />
          )}
        </div>
        <div className="panel-side">
          <CompositionTable
            composition={composition}
            colorByKey={colorByKey}
            metricKey={metricKey}
            metricLabel={label}
            dimensionLabel={dimensionLabel}
            formatter={formatter}
            total={total}
          />
        </div>
      </div>
    </div>
  );
};

export default MetricPanel;
